import { Badge, Button, FloatingToolbar, Row } from '@rematter/ui-web';
import { LucideTrash2, LucideX } from 'lucide-react';

import { useTranslations } from '../../i18n/useTranslations';

interface BookingsListFloatingToolbarProps {
  selectedCount: number;
  onBulkVoid: () => void;
  onClearSelection: () => void;
}

//
// ⚛️ ⚛️ ⚛️ BOOKINGS LIST FLOATING TOOLBAR ⚛️ ⚛️ ⚛️
//
export const BookingsListFloatingToolbar = ({
  selectedCount,
  onBulkVoid,
  onClearSelection,
}: BookingsListFloatingToolbarProps) => {
  const t = useTranslations();

  return (
    <FloatingToolbar
      visible={selectedCount > 0}
      className="@BookingsListFloatingToolbar"
    >
      <Row xBetween gap3>
        <Row gap2 className="text-sm">
          <Badge color="primary" size="small">
            {selectedCount}
          </Badge>{' '}
          {t.bookingsView.toolbar.selected}
        </Row>
        <Button
          variant="outline"
          icon={<LucideTrash2 />}
          isDisabled={selectedCount < 1}
          onPress={onBulkVoid}
        >
          {t.bookingsView.toolbar.delete(selectedCount)}
        </Button>
        <LucideX
          className="size-4 cursor-pointer text-neutral/80"
          onClick={onClearSelection}
        />
      </Row>
    </FloatingToolbar>
  );
};
